export type PdfOutput = "task_pdf" | "solution_pdf";
export const allPdfOutputs: PdfOutput[] = ["task_pdf", "solution_pdf"];

export function selectedPdfOutputs(value: unknown): PdfOutput[] {
  // Stored historical jobs had no preference and offered both PDFs.
  if (value === undefined || value === null) return [...allPdfOutputs];
  return Array.isArray(value) ? allPdfOutputs.filter(kind => value.includes(kind)) : [];
}

export function togglePdfOutput(current: PdfOutput[], kind: PdfOutput, checked: boolean): PdfOutput[] {
  const next = allPdfOutputs.filter(item => item === kind ? checked : current.includes(item));
  return next.length ? next : current;
}
